import { CloseIcon as Close } from "@l2r-front/l2r-icons"
import {
    BottomSheet as UIBottomSheet,
    L2RCheckbox,
    Divider as UiDivider,
    IconButton,
    List as UiList,
    styled,
    Typography as L2RTypography,
    Paper,
} from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 44
const DESKTOP_CONTAINER_WIDTH = 280
const CLOSE_BUTTON_SIZE = 24

export const Container = styled(Paper)(({ theme }) => ({
    borderRadius: theme.spacing(2),
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
    padding: theme.spacing(4, 0),
    width: DESKTOP_CONTAINER_WIDTH,
    maxHeight: "100%",
    overflowY: "auto",
}))

export const ContentWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 6),
    position: "relative",
    height: "100%",
}))

export const CloseButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    padding: 0,
    position: "absolute",
    height: CLOSE_BUTTON_SIZE,
    right: theme.spacing(6),
    top: 0,
    width: CLOSE_BUTTON_SIZE,
}))

export const CloseIcon = styled(Close)({
    height: 16,
    width: 16,
})

export const List = styled(UiList)(() => ({
    paddingTop: 0,
    paddingBottom: 0,
}))

export const Title = styled(L2RTypography, { shouldForwardProp: prop => !["isFirst"].includes(prop) })(({ isFirst, theme }) => ({
    display: "block",
    width: isFirst ? `calc(100% - ${CLOSE_BUTTON_SIZE}px - ${theme.spacing(3)})` : "100%",
}))

export const LayerList = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(5),
    marginTop: theme.spacing(4),
}))

export const Button = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,

    "&:hover": {
        backgroundColor: theme.palette["action/selected"].main,
    },
}))

export const Divider = styled(UiDivider)(({ theme }) => ({
    margin: theme.spacing(2, 0),
}))

export const BottomSheet = styled(UIBottomSheet)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 100,
}))

export const Checkbox = styled(L2RCheckbox)(({ disabled, theme }) => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    margin: theme.spacing(6, 0, 0, 0.5),
    marginTop: theme.spacing(4),

    "& .MuiCheckbox-root": {
        marginLeft: theme.spacing(-3),
    },
    "& .MuiFormControlLabel-label": {
        color: theme.palette["text/tertiary"].main,
        fontSize: theme.typography["Desktop & Mobile/Body/Label & Helper text"].fontSize,
    },
    "& .MuiSvgIcon-root": {
        color: disabled && theme.palette["text/tertiary"].main,
    },
}))